import { ReactNode, MouseEvent, useState } from 'react';
import IconButton from '../core/IconButton';
import { DialogWindow } from '../Dialog';
import { useIntl } from 'react-intl';
import { IconMoreVert } from '@/icons';

interface ActionButtonsProps {
  children: ReactNode;
}

export function ActionButtons({ children }: ActionButtonsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { formatMessage } = useIntl();

  // Close dialog if an action button is clicked in Mobile view
  const handleOpenChange = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (!isOpen) return;

    const target = e.target as HTMLButtonElement;
    const button = target.closest('[data-tooltip-id*="action-button"]');

    if (button) {
      setIsOpen(false);
    }
  };

  return (
    <>
      <DialogWindow
        title={formatMessage({ defaultMessage: 'Hantera' })}
        content={
          <div
            className="flex flex-col gap-4 [&>button]:w-full"
            onClick={handleOpenChange}
          >
            {children}
          </div>
        }
        dialogTrigger={
          <IconButton
            aria-label={formatMessage({ defaultMessage: 'Öppna meny' })}
            className="md:hidden"
            variant="ghost"
            icon={<IconMoreVert />}
          />
        }
        onOpenChange={setIsOpen}
        open={isOpen}
      />
      <div className="hidden gap-2 md:flex">{children}</div>
    </>
  );
}
